import constants from './constants';
import defaultConfig from './default';
/**       Private Methods      **/

/**
* Receive message from parent
* @param {object} event
*/
const _onMessage = function({ data }) {
  if (!data || typeof data !== 'string') return;
  const message = JSON.parse(data);

  if (this._events[message.type]) {
    this._events[message.type](message.data);
  }
}

/**
 * Post Message to parent
 * @param {object|string} message
*/
const _postMessage = function(message) {
  let event = '';

  if (typeof message === 'string') {
    event = message;
  } else {
    event = JSON.stringify(message);
  }

  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(event);
  } else if (document.postMessage) {
    document.postMessage(event);
  } else if (window.parent.postMessage) {
    window.parent.postMessage(event, '*');
  }
}

/**       BDK Class      **/
export default class GeniusBDK {
  constructor() {
    this._events = {};

    window.addEventListener("message", _onMessage.bind(this), false);
    document.addEventListener("message", _onMessage.bind(this), false);
  }

  /**
   * Add an Event Listener
   * @param {string} type
   * @param {function} callback 
  */
  addEventListener(type, callback) {
    this._events[type] = callback;
  }
  
  /**
   * Remove an Event Listener
   * @param {string} type
  */
  removeEventListener(type) {
    this._events[type] = undefined;
    delete this._events[type];
  }

  /**
   * get Configuration
  */
  getConfiguration() {
    return new Promise((resolve, reject) => {
      try {
        if (!window.ReactNativeWebView && window.parent.origin === window.origin) {
          return resolve(defaultConfig.configuration);
        }
      } catch (err) { }
      setTimeout(() => {
        _postMessage(`{ "type": "${constants.get.configuration}" }`);
        this.addEventListener(constants.set.configuration, (data) => {
          resolve(data);
          this.removeEventListener(constants.set.configuration);
        });
      }, 1000);
    });
  }

  /**
   * Update a Player's Score
   * @param {number} userId - isRequires
   * @param {number|string} score - score earned
   * @param {number|string} bonus - bonus earned
   * @param {number|string} penalty - penalty earned
   * @param {any} position - position of the player
  */
  updateMyScore(score = 0, bonus = 0, penalty = 0, position) {
    const toSend = {
      type: constants.set.score,
      data: {
        score: parseInt(score, 10),
        bonus: parseInt(bonus, 10),
        penalty: parseInt(penalty, 10),
        position,
      }
    };
    _postMessage(JSON.stringify(toSend));
  }
  
  /**
   * Update a Player's Score
   * @param {number} userId - isRequires
   * @param {number|string} score - score earned
   * @param {number|string} bonus - bonus earned
   * @param {number|string} penalty - penalty earned
   * @param {any} position - position of the player
  */
  updatePlayerScore(userId = null, score = 0, bonus = 0, penalty = 0, position = null) {
    if (!userId) {
      throw Error("The variable userId is required.")
    }

    const toSend = {
      type: constants.set.score,
      data: {
        userId,
        score: parseInt(score, 10),
        bonus: parseInt(bonus, 10),
        penalty: parseInt(penalty, 10),
        position,
      }
    };
    _postMessage(JSON.stringify(toSend));
  }

  /**
   * Get Completed Data
  */
  getResults() {
    return new Promise((resolve, reject) => {
      try {
        if (!window.ReactNativeWebView && window.parent.origin === window.origin) {
          return resolve(defaultConfig.results);
        }
      } catch (err) {}
      _postMessage(`{ "type": "${constants.get.results}" }`);
      this.addEventListener(constants.set.results, (data) => {
        resolve(data);
        this.removeEventListener(constants.set.results);
      });
    });
  }

  /**
   * Completed state
   * @param {any} options - option
  */
 completeGame(options) {
  const toSend = {
    type: constants.completed,
    data: options,
  };

  _postMessage(JSON.stringify(toSend));
}

  /**
   * Exit Modal game
   * @param {any} options - option
  */
  closeGame(options) {
    const toSend = {
      type: constants.exit,
      data: options,
    };
  
    _postMessage(JSON.stringify(toSend));
  }

}
